import { format } from 'date-fns';
import {
  filterTypeOptionsDate,
  filterTypeOptionsSimple,
  filterTypeOptionsPeriod,
  filterTypeOptionsText,
  filterTypeOptionsNumber,
} from '../../options';

const formatValue = (value, mFormat, isDate, isSimple) => {
  if (isSimple || mFormat === 'specific_date') {
    if (value === 'select_all') return null;
    return value?.value ?? value;
  }
  if (isDate && [
    'between', 'between_inc', 'before', 'before_inc', 'after', 'after_inc',
  ].includes(mFormat)) {
    return format(value, 'yyyy-MM-dd');
  }
  if (mFormat !== 'contains') {
    return Number(value);
  }
  return value;
};

const getActualTypeAndInverse = (ftype) => {
  const ftypeInfo = ftype.split('-');
  let actualFtype = ftypeInfo?.[1] || ftypeInfo?.[0];
  if (['lastY', 'lastM', 'lastD', 'lastQ', 'lastW', 'lastS'].includes(actualFtype)) {
    actualFtype = 'last';
  } else if (['nextY', 'nextM', 'nextD', 'nextQ', 'nextW', 'nextS'].includes(actualFtype)) {
    actualFtype = 'next';
  } else if (['previousY', 'previousM', 'previousD', 'previousQ', 'previousW', 'previousS'].includes(actualFtype)) {
    actualFtype = 'previous';
  } else if (['followingY', 'followingM', 'followingD', 'followingQ', 'followingW', 'followingS'].includes(actualFtype)) {
    actualFtype = 'following';
  } else if (['current_and_previousY', 'current_and_previousM', 'current_and_previousD', 'current_and_previousQ', 'current_and_previousW', 'current_and_previousS'].includes(actualFtype)) {
    actualFtype = 'current_and_previous';
  } else if (['current_and_followingY', 'current_and_followingM', 'current_and_followingD', 'current_and_followingQ', 'current_and_followingW', 'current_and_followingS'].includes(actualFtype)) {
    actualFtype = 'current_and_following';
  }
  return [
    ftypeInfo?.[0] === 'not',
    actualFtype,
  ];
};

const getSelectorByType = (ftype) => {
  switch (ftype) {
    case 'lastY':
    case 'not-lastY':
    case 'nextY':
    case 'not-nextY':
    case 'previousY':
    case 'not-previousY':
    case 'current_and_previousY':
    case 'not-current_and_previousY':
    case 'followingY':
    case 'not-followingY':
    case 'current_and_followingY':
    case 'not-current_and_followingY':
      return 'year';
    case 'lastM':
    case 'not-lastM':
    case 'nextM':
    case 'not-nextM':
    case 'previousM':
    case 'not-previousM':
    case 'current_and_previousM':
    case 'not-current_and_previousM':
    case 'followingM':
    case 'not-followingM':
    case 'current_and_followingM':
    case 'not-current_and_followingM':
      return 'M';
    case 'lastD':
    case 'not-lastD':
    case 'nextD':
    case 'not-nextD':
    case 'previousD':
    case 'not-previousD':
    case 'current_and_previousD':
    case 'not-current_and_previousD':
    case 'followingD':
    case 'not-followingD':
    case 'current_and_followingD':
    case 'not-current_and_followingD':
      return 'D';
    case 'lastQ':
    case 'not-lastQ':
    case 'nextQ':
    case 'not-nextQ':
    case 'previousQ':
    case 'not-previousQ':
    case 'current_and_previousQ':
    case 'not-current_and_previousQ':
    case 'followingQ':
    case 'not-followingQ':
    case 'current_and_followingQ':
    case 'not-current_and_followingQ':
      return 'Q';
    case 'lastW':
    case 'not-lastW':
    case 'nextW':
    case 'not-nextW':
    case 'previousW':
    case 'not-previousW':
    case 'current_and_previousW':
    case 'not-current_and_previousW':
    case 'followingW':
    case 'not-followingW':
    case 'current_and_followingW':
    case 'not-current_and_followingW':
      return 'W';
    case 'lastS':
    case 'not-lastS':
    case 'nextS':
    case 'not-nextS':
    case 'previousS':
    case 'not-previousS':
    case 'current_and_previousS':
    case 'not-current_and_previousS':
    case 'followingS':
    case 'not-followingS':
    case 'current_and_followingS':
    case 'not-current_and_followingS':
      return 'semester';
    default:
      return '';
  }
};

const getTypeOptions = (isSimple, columnType) => {
  if (isSimple) {
    return filterTypeOptionsSimple;
  }
  switch (columnType) {
    case 'date':
    case 'datetime64[ns]':
      return filterTypeOptionsPeriod.concat(filterTypeOptionsDate);
    case 'float':
    case 'int64':
    case 'float64':
      return filterTypeOptionsNumber;
    default:
      return filterTypeOptionsText;
  }
};

export {
  getActualTypeAndInverse,
  getSelectorByType,
  getTypeOptions,
  formatValue,
};
